import axios from "axios";


const API_URL = ""

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
})

// перехоплювач для додавання shared.options.log.id(wslog id) в data всіх запитів
api.interceptors.request.use(config => {
    const wsLogId = shared.options.log.id
    const wsLogUUId = shared.options.log.uuid

    if (config.method === 'get') {
        config.params = {
            s: wsLogId,
            ...(config.params || {})
        }
    } else if (config.data instanceof FormData) {
        config.data.append('s', wsLogId)
        config.data.append('suuid', wsLogUUId)
        config.data.append('uuid', wsLogUUId)
    } else {
        config.data = {
            s: wsLogId,
            suuid: wsLogUUId,
            uuid: wsLogUUId,
            ...config.data
        }
    }

    return config;
})

export default api

